import { render, staticRenderFns } from "./OdontogramaGerenciarServicos.vue?vue&type=template&id=34c6057a&scoped=true"
import script from "./OdontogramaGerenciarServicos.vue?vue&type=script&lang=js"
export * from "./OdontogramaGerenciarServicos.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaGerenciarServicos.vue?vue&type=style&index=0&id=34c6057a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c6057a",
  null
  
)

export default component.exports